export const MARKETPLACE_CATEGORIES = [
  { id: 'daily-routines', label: 'Daily Routines' },
  { id: 'email-comms', label: 'Email & Communications' },
  { id: 'meetings-calendar', label: 'Meetings & Calendar' },
  { id: 'project-management', label: 'Project Management' },
  { id: 'sales-outreach', label: 'Sales & Outreach' },
  { id: 'writing-content', label: 'Writing & Content' },
  { id: 'research-analysis', label: 'Research & Analysis' },
  { id: 'engineering-dev', label: 'Engineering & Development' },
  { id: 'people-team', label: 'People & Team' },
  { id: 'personal-productivity', label: 'Personal Productivity' },
] as const;

export type MarketplaceCategory = (typeof MARKETPLACE_CATEGORIES)[number];
export type MarketplaceCategoryId = MarketplaceCategory['id'];

export function isMarketplaceCategoryId(value: string): value is MarketplaceCategoryId {
  return MARKETPLACE_CATEGORIES.some((category) => category.id === value);
}

export function getMarketplaceCategoryLabel(categoryId: MarketplaceCategoryId): string {
  const match = MARKETPLACE_CATEGORIES.find((category) => category.id === categoryId);
  return match?.label ?? 'Personal Productivity';
}
